import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface DashboardGroupSectionWrapperProps {
  accentColor?: string;
}

const DashboardGroupSectionWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'accentColor',
})<DashboardGroupSectionWrapperProps>(({ theme, accentColor }) => {
  const accent = accentColor || theme.palette.border?.default || theme.palette.divider;

  return {
    marginBottom: 20,

    '& .collapse-header-wrapper': {
      background: theme.palette.background.paper,
      border: `1px solid ${accent} !important`,
      borderRadius: '3px !important',
      overflow: 'hidden',
      padding: '0 !important',

      '&::after': {
        border: `1px solid ${accent} !important`,
        borderTop: '0 !important',
        borderLeft: '0 !important',
        left: '20px !important',
        width: '6px !important',
        height: '6px !important',
        right: 'initial !important',
        top: '49% !important',
        transform: 'translateY(-70%) rotate(45deg) !important',
      },

      '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        width: 10,
        background: accent,
      },

      '& .MuiTypography-root': {
        color: accent,
      },

      '&.collapse-header-wrapper--open': {
        borderBottom: 0,

        '&::after': {
          transform: 'translateY(-20%) rotate(225deg) !important',
          top: '49% !important',
        },
      },
    },
  };
});

export default DashboardGroupSectionWrapper;
